<template lang="pug">
campaign-layout
  v-container(dark, fluid, grid-list-xl)
    v-flex(xs12)
      action-title-bar(title='Landing Pages', data-cy='title-bar')
    v-flex.xs12
      marketing-card(
        :properties='marketingConfig.landingPages'
      )
        template(slot='icon')
          v-icon.text-lg-center(x-large color='primary') menu_book
        template(slot='actions')
          v-layout(row wrap justify-center)
            v-flex.xs12
              v-btn(@click='startLandingPages' color='primary') {{ landingPagesButtonText() }}
            v-flex.xs12(v-if="landingPagesAddon")
              v-btn(@click='goToLandingPages' color='primary') Take me to Landing Pages

  plans-landing-pages(:dialog='showPlans', :hideLandingPagesDialog='hideLandingPagesDialog')
  page-payment-modal(v-if='showPageHosted', :dialog='showPageHosted')
  add-payment(v-if='showAddPayment', :dialog='showAddPayment')
  detail-plan-selected(v-if='showDetailPlanSelected', :dialog='showDetailPlanSelected')
  trial-upgrade-modal(
    v-if='showTrialUpgradeModal'
    v-show='showTrialUpgradeModal'
    @hide='showTrialUpgradeModal = false'
  )
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import CampaignLayout from '@/Campaigns/Layout';
import ActionTitleBar from '@/Core/components/ActionTitleBar';
import MARKETING_CONFIG from '@/Marketing/config';
import MarketingCard from '@/Marketing/components/MarketingCard';
import { setCookie } from '@/Core/utilities/set-cookie';
import { VALID_ADDON_STATUS_LIST } from '@/Core/config/addons';

export default {
  name: 'LandingPages',
  components: {
    MarketingCard,
    CampaignLayout,
    ActionTitleBar,
    TrialUpgradeModal: () => import (
      /*webpackChunkName: 'TrialUpgradeModal' */
      '@/Marketing/components/TrialUpgradeModal'),
    PlansLandingPages: () =>
      import(
        /*webpackChunkName: 'PlansLandingPages' */
        '@/Core/components/marketing/PlansLandingPages'
      ),
    PagePaymentModal: () =>
      import(
        /* webpackChunkName: 'PagePaymentModal' */
        '@/Core/components/marketing/PagePaymentModal'
      ),
    AddPayment: () =>
      import(/* webpackChunkName: 'AddPayment' */ '@/Core/components/marketing/AddPayment'),
    DetailPlanSelected: () =>
      import(
        /* webpackChunkName: 'DetailPlanSelected' */
        '@/Core/components/marketing/DetailPlanSelected'
      ),
  },
  data() {
    return {
      showLandingPagesDialog: false,
      marketingConfig: MARKETING_CONFIG,
      showTrialUpgradeModal: false,
    };
  },
  computed: {
    ...mapState('payment', [
      'showPlans',
      'showPageHosted',
      'showDetailPlanSelected',
      'showAddPayment',
      'landingPagesJWT',
    ]),
    ...mapState('userInformation', [
      'user',
    ]),
    ...mapGetters('payment', ['hasLandingPages', 'landingPagesAddon']),
  },
  methods: {
    ...mapActions('payment', ['setShowPlans', 'getUserAddons', 'getLandingPagesJWT']),
    hideLandingPagesDialog() {
      this.showLandingPagesDialog = false;
    },
    landingPagesButtonText() {
      return this.landingPagesAddon ? 'Manage Subscription' : 'Get Started';
    },
    startLandingPages() {
      if (this.user.subscriptionOverview.txt_status !== 'subscribed') {
        this.showTrialUpgradeModal = true;
      } else {
        this.setShowPlans(true);
      }
    },
    async goToLandingPages() {
      // commenting this out for new per convrrt's request, but will likely reimplement later
      // await this.getLandingPagesJWT();
      // setCookie('_pages_session', this.landingPagesJWT);
      window.location = process.env.VUE_APP_LANDING_PAGES_URL;
    },
  },
  async mounted() {
    await this.getUserAddons();
    if (!this.hasLandingPages) {
      this.$router.push('/');
    }
  },
};
</script>
